import PropTypes from 'prop-types';
import ActionButton from '../ActionButton/ActionButton'
import React from 'react';

const LinkActionButton = ({ buttonText, children, onClick, preventDefault, ...props }) => (
  <ActionButton
    variant='link'
    size='large'
    buttonText={buttonText}
    {...props}
    children={children}
    onClick={onClick}
    preventDefault={preventDefault}
    buttonClassName={''}
    buttonTextClassName={''}
    buttonChildrenClassName={''} />
)

LinkActionButton.propTypes = {
  buttonText: PropTypes.string.isRequired,
  children: PropTypes.node,
  onClick: PropTypes.func,
  preventDefault: PropTypes.bool
}

export default LinkActionButton
